import { EntityState, guid, ID } from '@datorama/akita';
import { BetFinalState } from 'src/app/shared/models/coupon-details.model';

export enum CashoutStatus {
  pending = 1,
  approved = 2,
  rejected = 3
}

export enum CashoutSource {
  recentBets,
  couponDetails
}

export enum CashoutStatusTab {
  Available,
  Unavailable,
  Requested
}

export interface CashoutState extends EntityState<CashoutModel> {}

export class CashoutModel {
  betCashout: BetCashoutModel;
  betFinalState: BetFinalState;
  cashoutId: number;
  couponCode: string;
  cashoutResponse: BetCashoutResponseModel;
  cashoutInProgress: boolean = false;
  cashoutRequested: boolean = false;
  cashoutSource: CashoutSource;
  id: ID = guid();
  userId: string;

  constructor(init: Partial<CashoutModel>) {
    Object.assign(this, init);
  }

  get cashoutStatusTab(): CashoutStatusTab {
    if (
      this.betFinalState === BetFinalState.Placed &&
      !this.cashoutRequested &&
      !this.betCashout.availability &&
      this.betCashout.message &&
      this.betCashout.message.length > 0
    ) {
      return CashoutStatusTab.Unavailable;
    } else if (this.betFinalState === BetFinalState.Placed && this.cashoutRequested) {
      return CashoutStatusTab.Requested;
    } else if (this.betFinalState === BetFinalState.Placed && !this.cashoutRequested && this.betCashout.availability) {
      return CashoutStatusTab.Available;
    }
  }
}
export class BetCashoutModel {
  availability: boolean;
  result: number;
  value: number;
  valueNet: number;
  tax: number;
  message: string;
  serverData: any;

  constructor(init: Partial<BetCashoutModel>) {
    Object.assign(this, init);
  }
}

export class BetCashoutResponseModel {
  success: boolean;
  cashoutAccepted: boolean;
  userMessage: string;
  responseCode: number;
  cashoutId: number;
  couponCode: string;
  cashoutValue: number;
  currencySymbol: string;

  constructor(init: Partial<BetCashoutResponseModel>) {
    Object.assign(this, init);
  }
}

export class CashoutStatusModel {
  status: CashoutStatus;
  cashoutId: number;
  couponCode: string;
  cashoutValue: number;
  currencySymbol: string;

  constructor(init: Partial<CashoutStatusModel>) {
    Object.assign(this, init);
  }
}
